import './App.css';
import About from './component/about/about';
import Intro from './component/intro/intro';
import ThemeContextWrapper from './component/ThemeContextWrapper';
import ProductList from './component/productList/ProductList';
import Contact from './component/contact/contact';
import Toggle from './component/toggle/toggle';
import Hmenu from './component/header/header';

function App() {
  return (
    <div className="App">
    <Hmenu></Hmenu>
      <ThemeContextWrapper>
        <Toggle></Toggle>
        <Intro/>
        <ProductList/>
        <Contact />
      </ThemeContextWrapper>

    </div>
  );
}

export default App;
